/** @file Deletes an event and every animation key that fires it (a warning counts the keys). */
import { defineCommand } from '../defineCommand';
import { defineRemove } from '../_shared/defineRemove';

const remove = defineRemove({ domain: 'event', kind: 'event', description: 'Delete an event; every key that fires it is removed too (a warning counts them).' });

/** event.delete: counts the keys that fire the event, then the factory removal; INFO { keys } when any. */
export const command = defineCommand({
  ...remove,
  apply(draft, input, ctx) {
    const id = ctx.resolve('event', input.target);
    const keys = Object.values(draft.animations).reduce((n, anim) => n + anim.events.filter((e) => e.event === id).length, 0);
    remove.apply(draft, input, ctx);
    if (keys > 0) ctx.warnings.push({ code: 'INFO', message: `also removed ${keys} event keys`, params: { keys }, path: 'target' });
  },
});
